import React from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Circle,
  useMapEvents,
  useMap,
} from "react-leaflet";

import "leaflet/dist/leaflet.css";

function Map({ lat, lng, uncertainty, setMapCoordinate }) {
  function SetViewOnClick({ coords }) {
    const map = useMap();
    map.setView(coords, map.getZoom());
    return null;
  }

  function MovableMarker() {
    useMapEvents({
      click(e) {
        setMapCoordinate([e.latlng.lat, e.latlng.lng]);
      },
    });

    return (
      <Marker
        position={[lat, lng]}
        draggable={true}
        eventHandlers={{
          dragend: (e) => {
            let latlng = e.target.getLatLng();
            console.log(latlng);
            setMapCoordinate([latlng.lat, latlng.lng]);
          },
        }}
      ></Marker>
    );
  }

  return (
    <MapContainer
      center={[lat, lng]}
      zoom={16}
      scrollWheelZoom={false}
      style={{ height: "40vh" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MovableMarker />
      <Circle center={[lat, lng]} radius={uncertainty} />

      <SetViewOnClick coords={[lat, lng]} />
    </MapContainer>
  );
}

export default Map;
